export default __webpack_public_path__ + "static/media/report_19.81508268.png";